import React, { useState, useEffect, useRef } from "react";
import * as XLSX from "xlsx";
import { Fragment } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { userService, roleService } from "../../../../services/extensions";
import { timesheetApi } from "../../../../services";
import { Button } from "primereact/button";
import { RadioButton } from "primereact/radiobutton";
import { Dialog } from "primereact/dialog";
import { Menu } from "primereact/menu";
import { PickList } from "primereact/picklist";
import Profile from "../../profile/user_profile";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { Dropdown } from "primereact/dropdown";
import DesignAction from "./DesignAction";
import NewProfile from "../../profile/newProfile";
import properties from "../../../../config/environmentProperties";
import ManageActionPopup from "./manageAction";
import BuAction from "./buAction";
import UserAllocationDialog from "./userAllocationDialog";
import UserCreateAllocationDialog from "./userCreateAllocation";
import UserLeaveDialog from "./UserLeaveDialog";
import "./style.scss";
import { capitalize } from "../../../../services/utility/helper";
import CONF from "../../../../config/appProperties";
import { Paginator } from "primereact/paginator";
import {
  USER_MAINTENANCE_MENU_ACTION_ROLE_VIEW,
  USER_MAINTENANCE_MENU_ACTION_MANAGER_VIEW,
  UPDATE_ATTENDENCE_INOUT_DATE,
  LEAVES_ADMIN,
  LEAVES_ADMIN_REGION_MAP,
} from "../../../../config/permissions";
import { hasPermission } from "../../../../components/protected/ProtectedSection";
import { Fieldset } from "primereact/fieldset";
import { Calendar } from "primereact/calendar";
import moment from "moment";
import { useSelector } from "react-redux";
import LeaveAdmin from "./views/leave-admin";

export const UserMaintenance = ({ limitFor = null }) => {
  const { user } = useSelector((state) => state.user);
  const [updateMarkAttendanceDate, setUpdateMarkAttendanceDate] =
    useState(false);
  const [attendanceDate, setAttendanceDate] = useState([]);
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const menu = useRef(null);
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [showUsers, setShowUsers] = useState(false);
  const [userProfile, setUserProfile] = useState(false);
  const [source, setScouce] = useState([]);
  const [target, setTarget] = useState([]);
  const [newForm, setNewForm] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [businessUnit, setBusinessUnit] = useState([]);
  const [designation, setDesignation] = useState([]);
  const [clickedUserId, setClickedUserId] = useState("");
  const [clickedUserECN, setClickedUserECN] = useState("");
  const [clickedUserData, setClickedUserData] = useState([]);
  const [selectBu, setSelectBu] = useState(false);
  const [mAction, setmAction] = useState(false);
  const [mDesignation, setmDesignation] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [vProfile, setvProfile] = useState(false);
  const [newUserDialog, setNewUserDialog] = useState(false);
  const imgPath = properties.currentEnvironment.docPath + "images/";
  const [userAllocation, setUserAllocation] = useState(false);
  const [clickAlloc, setClickAlloc] = useState([]);
  const [userReAllocation, setUserReAllocation] = useState(false);
  const [filters1, setFilters1] = useState(null);
  const [filterDialog, setFilterDialog] = useState(false);
  const [currentUser, setCurrentUser] = useState({});
  const [filterObj, setFilterObj] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [contentFirst, setContentFirst] = useState(0);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(CONF.pageSize);
  const [basicFirst, setBasicFirst] = useState(0);
  const [basicRows, setBasicRows] = useState(10);
  const [rowsPerPageOptions, setRowsPerPageOptions] = useState(
    CONF.rowsPerPageOptions,
  );
  const [resourceAvailable, setResourceAvailable] = useState("");
  const [managers, setManagers] = useState([]);
  const [userLeaveUpdate, setUserLeaveUpdate] = useState(false);
  const [filteredRecords, setFilteredRecords] = useState(false);
  const bgvFileRef = useRef(null);
  const [bgvConflictDialog, setBgvConflictDialog] = useState(false);
  const [bgvConflicts, setBgvConflicts] = useState([]);
  const [bgvPendingRecords, setBgvPendingRecords] = useState([]);

  let count = 0;
  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      ecn: "",
      phone: "",
      type: "",
      businessUnitId: "",
      status: "",
      superiorId: "",
      designationId: "",
    },
    validate: (data) => {
      let errors = {};
      if (!data.firstName) errors.firstName = "First Name is required.";
      if (!data.lastName) errors.lastName = "Last Name is required.";
      if (!data.email) {
        errors.email = "Email is required.";
      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.email)) {
        errors.email = "Invalid email address. E.g. example@espire.com";
      }
      if (!data.ecn) errors.ecn = "ECN is required.";
      if (!data.phone) errors.phone = "Phone is required.";
      if (!data.password) errors.password = "Password is required.";
      if (!data.type) errors.type = "Type is required.";
      return errors;
    },
    onSubmit: (data) => {
      setShowMessage(true);
      addUser(data);
    },
  });

  const searchForm = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      ecn: "",
      phone: "",
      designationId: "",
      businessUnitId: "",
      superiorId: "",
      status: 1,
    },
    validate: (data) => {
      let errors = {};
      return errors;
    },
    onSubmit: (data) => {
      setShowMessage(true);
      searchUser(data);
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };
  const status = [
    { label: "Active", value: 1 },
    { label: "Inactive", value: 2 },
  ];
  const type = [
    { label: "USER", value: "USER" },
    { label: "MANAGER", value: "MANAGER" },
    { label: "ADMIN", value: "ADMIN" },
  ];

  // Admin permission. Undefined for LEAVES_ADMIN (global) or null limitFor.
  const regionAdminConfig = limitFor ? LEAVES_ADMIN_REGION_MAP[limitFor] : undefined;

  // Helper: load users scoped to a region Leave Admin's LocationId via searchUsers API
  const loadRegionUsers = (locationId) => {
    const payload = { location: locationId, status: 1, isAdminFilter: true };
    userService.searchUsers(payload).then((resp) => {
      console.log(" loadRegionUsers response status:", resp.status, "count:", resp.data?.data?.length);
      if (resp.status === 200) {
        setUsers(resp.data.data);
        setFilteredRecords(true);
      }
    }).catch((err) => {
      console.error("[loadRegionUsers API error:", err);
    });
  };

  useEffect(() => {
    if (count == 0) {
      if (regionAdminConfig) {
        loadRegionUsers(regionAdminConfig.locationId);
      } else if (limitFor == null) {
        getUsers({ adminType: true, pageNum: 0, pageSize: size });
      }
    }
    count++;
    getManagers();
    getDesignations();
    getBusinessUnit();
  }, []);

  const searchUser = (data) => {
    setShowButton(true);
    var dataObj = {};

    // Always enforce location for the logged-in user's region Leave Admin permission
    if (regionAdminConfig) {
      dataObj.location = regionAdminConfig.locationId;
      dataObj.isAdminFilter = true;
    }

    if (data.ecn !== "") dataObj.ecn = data.ecn;
    if (data.firstName !== "") dataObj.firstName = data.firstName;
    if (data.lastName !== "") dataObj.lastName = data.lastName;
    if (data.email !== "") dataObj.email = data.email;
    if (data.designationId !== "") dataObj.designationId = data.designationId;
    if (data.businessUnitId !== "") dataObj.businessUnitId = data.businessUnitId;
    if (data.superiorId !== "") dataObj.superiorId = data.superiorId;
    if (data.status !== "") dataObj.status = data.status;
    if (regionAdminConfig && dataObj.status === undefined) {
      dataObj.status = 1;
    }

    // isClear checks only the form fields typed by the user
    let isClear = true;
    for (let v of Object.keys(data)) {
      if (data[v] != undefined && data[v] != "" && v !== "status") {
        isClear = false;
      }
    }

    // For a region admin: even if all form fields are empty, we MUST call the API
    // because dataObj already has location filter — skipping would show all users
    if (regionAdminConfig) {
      isClear = false;
    }

    if (isClear) {
      setShowMessage(false);
    }

    try {
      setFilterObj(dataObj);
      if (!isClear) {
        userService.searchUsers(dataObj).then(
          (resp) => {
            if (resp.status === 200) {
              setUsers(resp.data.data);
              setShowButton(false);
              setFilterDialog(false);
              setFilteredRecords(true);
            }
          },
          (error) => {
            console.error("searchUsers error:", error);
            setUsers();
            setShowButton(true);
          },
        );
      }
    } catch (error) {}
  };

  const addUser = (data) => {
    setShowButton(true);
    try {
      userService.addUser(data).then((resp) => {
        toast.success("User Added successfully!");
      });
    } catch (error) {
      toast.error("User not found!");
    }
  };

  const getManagers = () => {
    userService.getManagers().then((resp) => {
      try {
        resp.data.data.map(
          (user, index) =>
          (managers[index] = {
            id: user.id,
            name:
              user.firstName.charAt(0).toUpperCase() +
              user.firstName.slice(1) +
              " " +
              user.lastName.charAt(0).toUpperCase() +
              user.lastName.slice(1),
          }),
        );
      } catch (error) { }
    });
  };

  const getDesignations = (param = {}) => {
    userService.getDesignations().then((resp) => {
      setDesignation(resp.data.data);
    });
  };

  const getBusinessUnit = () => {
    userService.getBusinessUnit().then((resp) => {
      setBusinessUnit(resp.data.data);
    });
  };

  const getRoles = () => {
    roleService.getRoles().then((resp) => {
      const data = resp.data.data;
      setRoles(data);
      const sourceData = data.map((x) => {
        return { id: x.id, name: x.role_name };
      });
      setScouce(sourceData);
    });
  };

  const bu = [
    { label: "BU-H1", value: 1 },
    { label: "BU-H2", value: 2 },
    { label: "BU-H3", value: 3 },
    { label: "BU-H4", value: 4 },
    { label: "Organisation", value: 5 },
  ];

  const getUsers = (param = {}) => {
    if (param.pageNo === undefined) {
      setPage(0);
      setContentFirst(0);
    }
    timesheetApi.getUsersBySuperior(param).then((resp) => {
      try {
        setUsers(resp.data.data);
        setTotalRecords(resp.data.totalElement);
        setFilteredRecords(false);
      } catch (error) { }
    });
  };

  const onHide = () => {
    setShowUsers(false);
  };

  const onShowRoles = (rowData) => {
    getRoles();
    try {
      const targetData = currentUser.UserRoles.map((x) => {
        return { id: x.role_id, name: x.Role.role_name };
      });
      setTarget(targetData);
    } catch (error) { }
    setShowUsers(true);
  };

  const assignDesignation = (rowData) => {
    setClickedUserId(currentUser.id);
    setmDesignation(true);
  };

  const onManagerAction = (rowData) => {
    setClickedUserId(currentUser.id);
    setmAction(true);
  };

  const onBuAction = (rowData) => {
    setClickedUserId(currentUser.id);
    setSelectBu(true);
  };

  const getCurrentUserDetails = (rowData) => {
    setClickedUserECN(currentUser.ecn);
    setUserProfile(true);
    setClickedUserId(currentUser.id);
    setvProfile(true);
  };

  const assignEmployeeBu = (data) => {
    let param = {
      userIds: [clickedUserId],
      businessUnitId: data.bu.id,
    };
    try {
      userService.assignBuToEmployee(param).then((resp) => {
        if (resp) {
          setSelectBu(false);
          toast.info("Business Unit assigned successfully!");
          if (filterObj !== "") {
            try {
              userService.searchUsers(filterObj).then(
                (resp) => {
                  if (resp.status === 200) {
                    setUsers(resp.data.data);
                    setShowButton(false);
                    searchForm.resetForm();
                    setFilterDialog(false);
                  }
                },
                (error) => {
                  setUsers();
                  setShowButton(true);
                },
              );
            } catch (error) { }
          } else {
            getUsers({ adminType: true, pageNum: 0, pageSize: size });
          }
        }
      });
    } catch (error) {
      toast.error("Unable to assigned Business Unit!");
    }
  };

  const assignEmployeeManager = (data) => {
    let param = {
      userIds: [clickedUserId],
      superiorId: data.manager.id,
    };
    try {
      userService.assignManagerToEmployee(param).then((resp) => {
        if (resp) {
          setmAction(false);
          toast.info("Reporting Manager assigned successfully!");
        }
      });
    } catch (error) {
      toast.error("Unable to assigned Reporting Manager!");
    }
  };

  const assignEmployeeDesignation = (data) => {
    let param = {
      userIds: [clickedUserId],
      designationId: data.designation.id,
    };
    try {
      userService.assignDesignationToEmployee(param).then((resp) => {
        if (resp) {
          setmDesignation(false);
          toast.info("Designation assigned successfully!");
          if (filterObj !== "") {
            try {
              userService.searchUsers(filterObj).then(
                (resp) => {
                  if (resp.status === 200) {
                    setUsers(resp.data.data);
                    setShowButton(false);
                    searchForm.resetForm();
                    setFilterDialog(false);
                  }
                },
                (error) => {
                  setUsers();
                  setShowButton(true);
                },
              );
            } catch (error) { }
          } else {
            getUsers({ adminType: true, pageNum: 0, pageSize: size });
          }
        }
      });
    } catch (error) {
      toast.error("Unable to assign Designation!");
    }
  };

  const clickAllocation = () => {
    setClickedUserData(currentUser);
    const activeProjects = currentUser.Allocations.filter((x) => {
      return x.status !== 4;
    });
    setClickAlloc(activeProjects);
    setResourceAvailable(currentUser.availability);
    setUserAllocation(true);
  };

  const BuDialog = () => {
    return (
      <div className="flex align-items-center flex-column">
        <Dialog
          header="Update Business Unit"
          visible={selectBu}
          onHide={() => setSelectBu(false)}
          style={{ width: "430px" }}
        >
          <BuAction
            assignBu={(data) => assignEmployeeBu(data)}
            onClose={(e) => setSelectBu(false)}
          />
        </Dialog>
      </div>
    );
  };

  const ManagerAction = () => {
    return (
      <div className="flex align-items-center flex-column">
        <Dialog
          header="Update Reporting Manager"
          visible={mAction}
          onHide={() => setmAction(false)}
          style={{ width: "430px" }}
        >
          <ManageActionPopup
            assignManager={(data) => assignEmployeeManager(data)}
            onClose={(e) => setmAction(false)}
          />
        </Dialog>
      </div>
    );
  };

  const Designation = () => {
    return (
      <div className="flex align-items-center flex-column">
        <Dialog
          header="Update Designation"
          visible={mDesignation}
          onHide={() => setmDesignation(false)}
          style={{ width: "430px" }}
        >
          <DesignAction
            assignDesign={(data) => assignEmployeeDesignation(data)}
            onClose={(e) => setmDesignation(false)}
          />
        </Dialog>
      </div>
    );
  };

  const designationTemplate = (data) => {
    return (
      <span style={{ textTransform: "capitalize" }}>
        {data?.Designation?.title}
      </span>
    );
  };

  const buTemplate = (data) => {
    return data?.BusinessUnit?.title;
  };

  const bgvBodyTemplate = (data) => {
    if (data?.background_verification === true && data?.bgv_comment === "Closed") {
      return <i className="pi pi-check-circle" style={{ color: "#008000", fontSize: "1.2rem" }} title={"Verification Completed"}/>;
    }

    if (data?.background_verification === true && data?.bgv_comment === "Pending Verification") {
      return <i className="pi pi-shield" style={{ color: "#008000", fontSize: "1.2rem" }} title={"Data pending from HR team to be update"} />;
    }
    return (
      <i
        className="pi pi-info-circle"
        style={{ fontSize: "1.2rem", cursor: "default", color: "#6c757d" }}
        title={data?.bgv_comment || "No comment"}
      />
    );
  };

  const header = (clickedUserData) => {
    return (
      <div className="grid">
        <div className="col-9">
          <h1 style={{ fontSize: "23px" }}>
            Allocation Management: {capitalize(clickedUserData.firstName)}{" "}
            {capitalize(clickedUserData.lastName)}
          </h1>
        </div>
        <div className="col-3 mt-3">
          <Button
            icon="pi pi-plus-circle"
            label="Create Allocation"
            className="p-button-sm p-button-rounded p-button-icon"
            style={{ float: "right" }}
            onClick={() => {
              setUserReAllocation(true);
              setUserAllocation(false);
            }}
          ></Button>
        </div>
      </div>
    );
  };

  const Allocation = () => {
    return (
      <div className="flex align-items-center flex-column">
        <Dialog
          header={() => header(clickedUserData)}
          visible={userAllocation}
          onHide={() => updateAdminAllocation()}
        >
          <UserAllocationDialog
            onClose={(e) => updateAdminAllocation()}
            projectData={clickAlloc}
            resourceAvailablity={resourceAvailable}
          />
        </Dialog>
      </div>
    );
  };

  const updateAdminAllocation = () => {
    setUserAllocation(false);
    setUserReAllocation(false);
    getUsers({ adminType: true, pageNum: 0, pageSize: size });
  };

  const ReAllocation = () => {
    return (
      <div className="flex align-items-center flex-column">
        <Dialog
          header="New Allocation"
          visible={userReAllocation}
          onHide={() => setUserReAllocation(false)}
          style={{ minWidth: "30rem" }}
        >
          <UserCreateAllocationDialog
            onClose={(e) => updateAdminAllocation()}
            userData={clickedUserData}
          />
        </Dialog>
      </div>
    );
  };

  const onClickLeaveUpdate = () => {
    setClickedUserData(currentUser);
    setUserLeaveUpdate(true);
  };

  const leaveHeader = (clickedUserData) => {
    return (
      <div className="grid">
        <div style={{ width: "500px" }}>
          <h1 style={{ fontSize: "23px", margin: 0, padding: 0 }}>
            Leave Details:
            <strong
              style={{
                color: "#c91919",
                fontSize: "23px",
                fontWeight: "600",
                marginLeft: "5px",
              }}
            >
              {capitalize(clickedUserData.firstName)}{" "}
              {capitalize(clickedUserData.lastName)}
            </strong>
          </h1>
        </div>
      </div>
    );
  };

  const LeaveUpdate = () => {
    return (
      <div className="flex align-items-center flex-column">
        <Dialog
          header={() => leaveHeader(clickedUserData)}
          style={{ width: "1000px" }}
          visible={userLeaveUpdate}
          onHide={() => setUserLeaveUpdate(false)}
        >
          <UserLeaveDialog
            onClose={() => setUserLeaveUpdate(false)}
            clickedUserData={clickedUserData}
          />
        </Dialog>
      </div>
    );
  };

  const onChange = (event) => {
    setRoles(event.source);
    setTarget(event.target);
  };

  const fetchStatus = (status) => {
    if (status === 0) return "INACTIVE";
    if (status === 1) return "ACTIVE";
  };

  const fetchStatusColor = (status) => {
    if (status === 0) return "red";
    if (status === 1) return "#008000";
  };

  const statusBodyTemplate = (data) => {
    return (
      <span
        style={{
          color: fetchStatusColor(data.status),
          borderRadius: "8px",
          fontSize: "12px",
          fontWeight: "700",
        }}
      >
        {" "}
        {fetchStatus(data.status)}{" "}
      </span>
    );
  };

  /* Update Mark Attendance Date */
  const attendanceDateUpdate = (e) => {
    let dateInTimeZone = new Date(
      attendanceDate.toLocaleString("en-US", { timeZone: timeZone }),
    );
    try {
      let param = {
        updatedAttendanceDate: moment(dateInTimeZone).format("YYYY-MM-DD"),
        userId: currentUser.id,
      };
      userService.updateUserAttendanceDate(param).then(
        (resp) => {
          if (resp) {
            setUpdateMarkAttendanceDate(false);
            toast.success("Attendance Date has been updated successfully..");
          }
        },
        (err) => {
          toast.error("There was some error while updating Attendance Date...");
        },
      );
    } catch (error) {
      console.error(
        "There was some error while updating Attendance Date...",
        error,
      );
    }
  };

  const updateMarkAttendanceDateDialoge = () => {
    return (
      <Dialog
        className="pop-up-dialog"
        style={{ width: "600px", padding: "10px" }}
        header={"Update Attendance Date"}
        visible={updateMarkAttendanceDate}
        onHide={() => setUpdateMarkAttendanceDate(false)}
      >
        <Fieldset>
          <div style={{ display: "flex", padding: "15px" }}>
            <Calendar
              value={attendanceDate}
              onChange={(e) => setAttendanceDate(e.value)}
              dateFormat="dd/mm/yy"
              showIcon
              placeholder="Select Date"
              showButtonBar
            />
            <Button
              label="Update"
              className="ml-7"
              onClick={() => attendanceDateUpdate()}
            ></Button>
            <Button
              label="Cancel"
              className="ml-4"
              onClick={() => setUpdateMarkAttendanceDate(false)}
            ></Button>
          </div>
        </Fieldset>
      </Dialog>
    );
  };

  const ActionTemplate = (rowData) => {
    let items;
    if (limitFor === null) {
      if (hasPermission(USER_MAINTENANCE_MENU_ACTION_ROLE_VIEW)) {
        items = [
          {
            label: "Views",
            items: [{ label: "View Profile", icon: "pi pi-user", command: () => { getCurrentUserDetails(rowData); } }],
          },
          {
            label: "Assignments",
            items: [{ label: "Allocation", icon: "pi pi-user-plus", command: (e) => { clickAllocation(); } }],
          },
          {
            label: "Updates",
            items: [{ label: "Manager", icon: "pi pi-user-edit", command: (e) => { onManagerAction(rowData); } }],
          },
        ];
      } else if (hasPermission(UPDATE_ATTENDENCE_INOUT_DATE)) {
        items = [
          {
            label: "Attendance",
            items: [{ label: "Update In/Out Date", icon: "pi pi-pencil", command: () => { setUpdateMarkAttendanceDate(true); } }],
          },
        ];
      } else if (hasPermission(USER_MAINTENANCE_MENU_ACTION_MANAGER_VIEW)) {
        items = [
          {
            label: "Views",
            items: [{ label: "View Profile", icon: "pi pi-user", command: () => { getCurrentUserDetails(rowData); } }],
          },
          {
            label: "Assignments",
            items: [{ label: "Allocation", icon: "pi pi-user-plus", command: (e) => { clickAllocation(); } }],
          },
        ];
      } else {
        items = [
          {
            label: "Views",
            items: [{ label: "View Profile", icon: "pi pi-user", command: () => { getCurrentUserDetails(rowData); } }],
          },
          {
            label: "Assignments",
            items: [
              { label: "Roles", icon: "pi pi-users", command: () => { onShowRoles(rowData); } },
              { label: "Allocation", icon: "pi pi-user-plus", command: (e) => { clickAllocation(); } },
            ],
          },
          {
            label: "Updates",
            items: [
              { label: "Business Unit", icon: "pi pi-id-card", command: (e) => { onBuAction(rowData); } },
              { label: "Designation", icon: "pi pi-briefcase", command: (e) => { assignDesignation(rowData); } },
              { label: "Manager", icon: "pi pi-shield", command: (e) => { onManagerAction(rowData); } },
              { label: "Leaves", icon: "pi pi-calendar", command: (e) => { onClickLeaveUpdate(); } },
            ],
          },
        ];
      }
    } else {
      if (hasPermission(LEAVES_ADMIN) && limitFor === "LEAVES_ADMIN") {
        items = [
          {
            label: "Views",
            items: [{ label: "View Profile", icon: "pi pi-user", command: () => { getCurrentUserDetails(rowData); } }],
          },
          {
            label: "Updates",
            items: [{ label: "Leaves", icon: "pi pi-calendar", command: (e) => { onClickLeaveUpdate(); } }],
          },
        ];
      }
      if (regionAdminConfig && hasPermission(regionAdminConfig.permission)) {
        items = [
          {
            label: "Views",
            items: [{ label: "View Profile", icon: "pi pi-user", command: () => { getCurrentUserDetails(rowData); } }],
          },
          {
            label: "Updates",
            items: [{ label: "Leaves", icon: "pi pi-calendar", command: (e) => { onClickLeaveUpdate(); } }],
          },
        ];
      }
    }
    return (
      <>
        <Menu id={"m-" + rowData.id} model={items} popup ref={menu} />
        <Button
          className="p-button-rounded p-button-text"
          id={"b-" + rowData.id}
          icon="pi pi-ellipsis-v"
          onClick={(event) => {
            setCurrentUser(rowData);
            menu.current.toggle(event);
          }}
          aria-controls={"m-" + rowData.id}
          aria-haspopup
        />
      </>
    );
  };

  const itemBody = (item) => {
    return <span>{item.name}</span>;
  };

  const assignRole = (e) => {
    const payload = {
      userId: currentUser.id,
      roleIds: target.map((x) => { return x.id; }),
    };
    userService.assignRoleToEmployee(payload).then((resp) => {
      getUsers({ adminType: true, pageNum: 0, pageSize: size });
      setShowUsers(false);
    });
  };
  const RoleList = () => {
    const headerText = "Assign Roles";
    return (
      <Fragment>
        <div className="flex align-items-center flex-column">
          <Dialog
            header={headerText}
            visible={showUsers}
            onHide={() => onHide()}
            style={{ width: "500px" }}
          >
            <PickList
              source={source}
              target={target}
              itemTemplate={itemBody}
              sourceHeader="Available Roles"
              targetHeader="Assigned Roles"
              showSourceControls={false}
              showTargetControls={false}
              sourceStyle={{ height: "250px" }}
              targetStyle={{ height: "250px" }}
              onChange={onChange}
            />
            <div className="pt-4">
              <div className="grid" style={{ float: "right" }}>
                <div>
                  <Button
                    type="button"
                    label="Submit"
                    className="p-button-rounded"
                    onClick={assignRole}
                  />
                </div>
              </div>
            </div>
          </Dialog>
        </div>
      </Fragment>
    );
  };

  const UserProfile = () => {
    const headerText = "Profile";
    return (
      <Fragment>
        <Dialog
          header={headerText}
          visible={userProfile}
          onHide={() => setUserProfile(false)}
          style={{ width: "70%", height: "70%" }}
        >
          <Profile userECN={currentUser.ecn} />
          <NewProfile getRowId={currentUser.id} />
        </Dialog>
      </Fragment>
    );
  };

  const UserView = () => {
    const headerText = "Profile";
    return (
      <Fragment>
        <Dialog
          header={headerText}
          visible={vProfile}
          onHide={() => setvProfile(false)}
          style={{ width: "70%", height: "70%" }}
        >
          <NewProfile getRowId={clickedUserId} />
        </Dialog>
      </Fragment>
    );
  };

  const SearchForm = () => {
    return (
      <Fragment>
        <Dialog
          header="User Filter"
          visible={filterDialog}
          position="right"
          modal
          style={{ width: "500px" }}
          onHide={() => setFilterDialog(false)}
          draggable={false}
          resizable={false}
        >
          <form onSubmit={searchForm.handleSubmit}>
            <div className="grid p-fluid">
              <div className="col-6 field">
                <label htmlFor="firstName" className={classNames({ "p-error": isFormFieldValid("firstName") })}>
                  First Name
                </label>
                <span className="p-float-label">
                  <InputText
                    name="firstName"
                    value={searchForm.values.firstName}
                    onChange={searchForm.handleChange}
                  />
                </span>
              </div>
              <div className="col-6 field">
                <label htmlFor="lastName" className={classNames({ "p-error": isFormFieldValid("lastName") })}>
                  Last Name
                </label>
                <span className="p-float-label">
                  <InputText
                    name="lastName"
                    value={searchForm.values.lastName}
                    onChange={searchForm.handleChange}
                  />
                </span>
              </div>
              <div className="col-6 field">
                <label htmlFor="ecn" className={classNames({ "p-error": isFormFieldValid("ecn") })}>
                  ECN
                </label>
                <span className="p-float-label">
                  <InputText
                    name="ecn"
                    value={searchForm.values.ecn}
                    onChange={searchForm.handleChange}
                  />
                </span>
              </div>
              <div className="col-6 field">
                <label className={classNames({ "p-error": isFormFieldValid("email") })}>
                  Email Address
                </label>
                <span className="p-float-label">
                  <InputText
                    name="email"
                    value={searchForm.values.email}
                    onChange={searchForm.handleChange}
                  />
                </span>
              </div>
              <div className="col-6 field">
                <label className={classNames({ "p-error": isFormFieldValid("bu") })}>
                  Business Unit
                </label>
                <span className="p-float-label">
                  <Dropdown
                    name="businessUnitId"
                    optionLabel="code"
                    optionValue="id"
                    value={searchForm.values.businessUnitId}
                    onChange={searchForm.handleChange}
                    options={businessUnit}
                  />
                </span>
              </div>
              <div className="col-6 field">
                <label className={classNames({ "p-error": isFormFieldValid("designation") })}>
                  Designation
                </label>
                <span className="p-float-label">
                  <Dropdown
                    filter
                    id="designationId"
                    name="designationId"
                    optionLabel="title"
                    optionValue="id"
                    value={searchForm.values.designationId}
                    onChange={searchForm.handleChange}
                    options={designation}
                    placeholder="Select designation"
                    className={classNames({ "p-invalid": isFormFieldValid("designation") })}
                  />
                </span>
              </div>
              <div className="col-6 field">
                <label className={classNames({ "p-error": isFormFieldValid("rm") })}>
                  Reporting Manager
                </label>
                <span className="p-float-label">
                  <Dropdown
                    filter
                    name="superiorId"
                    value={searchForm.values.superiorId}
                    onChange={searchForm.handleChange}
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Select reporting nanager"
                    className={classNames({ "p-invalid": isFormFieldValid("rm") })}
                    options={managers}
                  />
                </span>
              </div>
              <div className="col-6 field">
                <label className={classNames({ "p-error": isFormFieldValid("rm") })}>
                  Status
                </label>
                <span className="p-float-label grid mt-1">
                  <div className="col field-radiobutton">
                    <RadioButton
                      inputId="status"
                      name="status"
                      value={1}
                      onChange={() => searchForm.setFieldValue("status", 0)}
                      checked={searchForm.values.status === 1}
                    />
                    <span className="ml-2" htmlFor="status">Active</span>
                  </div>
                  <div className="col field-radiobutton">
                    <RadioButton
                      inputId="status"
                      name="status"
                      value={0}
                      onChange={() => searchForm.setFieldValue("status", 0)}
                      checked={searchForm.values.status === 0}
                    />
                    <span className="ml-2" htmlFor="status">In-Active</span>
                  </div>
                </span>
              </div>
            </div>
            <div className="col-12">
              <Button type="submit" icon="pi pi-search" label="Search" className="p-button-rounded" />
              <Button
                type="button"
                icon="pi pi-refresh"
                label="Reset"
                className="p-button-rounded ml-1"
                onClick={() => {
                  searchForm.resetForm();
                  setFilterObj("");
                  setFilterDialog(false);
                  if (regionAdminConfig) {
                    loadRegionUsers(regionAdminConfig.locationId);
                  } else {
                    setFilteredRecords(false);
                    getUsers({ adminType: true, pageNum: 0, pageSize: size });
                  }
                }}
              />
            </div>
          </form>
        </Dialog>
      </Fragment>
    );
  };

  const NewForm = () => {
    return (
      <Fragment>
        <Dialog
          header="Add User"
          visible={newForm}
          position="right"
          modal
          style={{ width: "500px" }}
          onHide={() => setNewForm(false)}
          draggable={false}
          resizable={false}
        >
          <form onSubmit={formik.handleSubmit}>
            <div className="grid p-fluid">
              <div className="col-6 field">
                <label htmlFor="firstName">First Name<span style={{ color: "red" }}>*</span></label>
                <span className="p-float-label">
                  <InputText
                    id="firstName"
                    name="firstName"
                    value={formik.values.firstName}
                    onChange={formik.handleChange}
                    className={classNames({
                      "p-invalid": isFormFieldValid("firstName"),
                    })}
                  />
                </span>
                {getFormErrorMessage("firstName")}
              </div>
              <div className="col-6 field">
                <label htmlFor="lastName">Last Name<span style={{ color: "red" }}>*</span></label>
                <span className="p-float-label">
                  <InputText
                    id="lastName"
                    name="lastName"
                    value={formik.values.lastName}
                    onChange={formik.handleChange}
                    className={classNames({
                      "p-invalid": isFormFieldValid("lastName"),
                    })}
                  />
                </span>
                {getFormErrorMessage("lastName")}
              </div>
              <div className="col-6 field">
                <label htmlFor="email">Email Address<span style={{ color: "red" }}>*</span></label>
                <span className="p-float-label">
                  <InputText
                    id="email"
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    className={classNames({
                      "p-invalid": isFormFieldValid("email"),
                    })}
                  />
                </span>
                {getFormErrorMessage("email")}
              </div>
              <div className="col-6 field">
                <label htmlFor="phone">Phone<span style={{ color: "red" }}>*</span></label>
                <span className="p-float-label">
                  <InputText
                    id="phone"
                    name="phone"
                    value={formik.values.phone}
                    onChange={formik.handleChange}
                    className={classNames({
                      "p-invalid": isFormFieldValid("phone"),
                    })}
                  />
                </span>
                {getFormErrorMessage("phone")}
              </div>
              <div className="col-6 field">
                <label htmlFor="password">Password<span style={{ color: "red" }}>*</span></label>
                <span className="p-float-label">
                  <InputText
                    id="password"
                    name="password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    className={classNames({
                      "p-invalid": isFormFieldValid("password"),
                    })}
                  />
                </span>
                {getFormErrorMessage("password")}
              </div>
              <div className="col-6 field">
                <label htmlFor="type">Type<span style={{ color: "red" }}>*</span></label>
                <span className="p-float-label">
                  <Dropdown
                    id="type"
                    name="type"
                    value={formik.values.type}
                    onChange={formik.handleChange}
                    className={classNames({
                      "p-invalid": isFormFieldValid("type"),
                    })}
                    options={type}
                  />
                </span>
                {getFormErrorMessage("type")}
              </div>
              <div className="col-6 field">
                <label htmlFor="ecn">ECN<span style={{ color: "red" }}>*</span></label>
                <span className="p-float-label">
                  <InputText
                    id="ecn"
                    name="ecn"
                    value={formik.values.ecn}
                    onChange={formik.handleChange}
                    className={classNames({
                      "p-invalid": isFormFieldValid("ecn"),
                    })}
                  />
                </span>
                {getFormErrorMessage("ecn")}
              </div>
              <div className="col-6 field">
                <label htmlFor="designationId">Designation</label>
                <span className="p-float-label">
                  <Dropdown
                    filter
                    id="designationId"
                    name="designationId"
                    optionLabel="title"
                    optionValue="id"
                    value={formik.values.designationId}
                    onChange={formik.handleChange}
                    options={designation}
                    placeholder="Select designation"
                    className={classNames({
                      "p-invalid": isFormFieldValid("designation"),
                    })}
                  />
                </span>
              </div>
              <div className="col-6 field">
                <label htmlFor="businessUnitId">Business Unit</label>
                <span className="p-float-label">
                  <Dropdown
                    name="businessUnitId"
                    optionLabel="code"
                    optionValue="id"
                    value={formik.values.businessUnitId}
                    onChange={formik.handleChange}
                    options={businessUnit}
                  />
                </span>
              </div>
              <div className="col-6 field">
                <label htmlFor="superiorId">Reporting Manager</label>
                <span className="p-float-label">
                  <Dropdown
                    filter
                    name="superiorId"
                    value={formik.values.superiorId}
                    onChange={formik.handleChange}
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Select reporting nanager"
                    className={classNames({
                      "p-invalid": isFormFieldValid("rm"),
                    })}
                    options={managers}
                  />
                </span>
              </div>
              <div className="col-6 field">
                <label htmlFor="status">Status</label>
                <span className="p-float-label">
                  <Dropdown
                    id="status"
                    name="status"
                    value={formik.values.status}
                    onChange={formik.handleChange}
                    className={classNames({
                      "p-invalid": isFormFieldValid("status"),
                    })}
                    options={status}
                  />
                </span>
              </div>
            </div>
            <div className="col-12">
              <Button
                type="submit"
                icon="pi pi-plus"
                label="Add User"
                className="p-button-rounded"
              />
              <Button
                type="button"
                icon="pi pi-times"
                label="Cancel"
                className="p-button-rounded p-button-secondary ml-2"
                onClick={cancelHandler}
              />
            </div>
          </form>
        </Dialog>
      </Fragment>
    );
  };

  const handleBgvFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (evt) => {
      const wb = XLSX.read(evt.target.result, { type: "binary" });
      const ws = wb.Sheets[wb.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(ws, { header: 1 });
      const records = [];
      for (const row of rows) {
        if (!row || row.length < 3) continue;
        const ecn = String(row[0] ?? "").trim();
        const employeeName = String(row[1] ?? "").trim();
        const status = String(row[2] ?? "").trim();
        // Skip empty or header rows (ECN must be non-empty and status must be a known value)
        if (!ecn || !status || ecn.toLowerCase() === "ecn" || ecn.toLowerCase() === "employee code") continue;
        records.push({ ecn, employeeName, status });
      }
      if (records.length === 0) {
        toast.warn("No valid records found in the Excel file.");
        return;
      }
      submitBgvRecords(records, false);
    };
    reader.readAsBinaryString(file);
    e.target.value = "";
  };

  const submitBgvRecords = (records, forceUpdate) => {
    userService.updateBgvStatus({ records, forceUpdate }).then((resp) => {
      if (resp.data.hasConflicts) {
        setBgvConflicts(resp.data.conflicts);
        setBgvPendingRecords(records);
        setBgvConflictDialog(true);
      } else if (resp.data.success) {
        toast.success("BGV status updated successfully!");
        setBgvConflictDialog(false);
        setBgvConflicts([]);
        setBgvPendingRecords([]);
      }
    }).catch(() => toast.error("Failed to update BGV status."));
  };

  const handleBgvSkipConflicts = () => {
    const conflictEcnSet = new Set(bgvConflicts.map((c) => c.ecn));
    const nonConflictRecords = bgvPendingRecords.filter((r) => !conflictEcnSet.has(r.ecn));
    if (nonConflictRecords.length === 0) {
      toast.info("No records to update after skipping conflicts.");
      setBgvConflictDialog(false);
      setBgvConflicts([]);
      setBgvPendingRecords([]);
      return;
    }
    userService.updateBgvStatus({ records: nonConflictRecords, forceUpdate: false }).then((resp) => {
      if (resp.data.success) {
        toast.success("BGV status updated successfully!");
      }
    }).catch(() => toast.error("Failed to update BGV status."))
      .finally(() => {
        setBgvConflictDialog(false);
        setBgvConflicts([]);
        setBgvPendingRecords([]);
      });
  };

  const BgvConflictDialog = () => (
    <Dialog
      header="BGV Status Conflict"
      visible={bgvConflictDialog}
      style={{ width: "550px" }}
      onHide={() => { setBgvConflictDialog(false); setBgvConflicts([]); setBgvPendingRecords([]); }}
    >
      <p style={{ marginBottom: "10px" }}>
        The following employees already have BGV verified (true) in the system but the uploaded Excel has a different status:
      </p>
      <ul style={{ marginBottom: "16px", paddingLeft: "20px" }}>
        {bgvConflicts.map((c, i) => (
          <li key={i}><strong>{c.ecn}</strong> - {c.name} &rarr; <em>{c.newStatus}</em></li>
        ))}
      </ul>
      <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
        <Button
          label="Force Update"
          className="p-button-danger p-button-rounded"
          onClick={() => submitBgvRecords(bgvPendingRecords, true)}
        />
        <Button
          label="Update"
          className="p-button-rounded"
          onClick={handleBgvSkipConflicts}
        />
        <Button
          label="Cancel"
          className="p-button-rounded p-button-secondary"
          onClick={() => { setBgvConflictDialog(false); setBgvConflicts([]); setBgvPendingRecords([]); }}
        />
      </div>
    </Dialog>
  );

  const cancelHandler = () => {
    formik.resetForm();
    setNewUserDialog(false);
    setNewForm(false);
  };

  const tableHeader = () => {
    return (
      <Fragment>
        <div className="grid">
          <div
            className="col mt-3 mb-2"
            style={{ paddingLeft: "25px", paddingRight: "21px" }}
          >
            <span className="heading">
              User's List
              <div className="heading-actions">
                {hasPermission(USER_MAINTENANCE_MENU_ACTION_ROLE_VIEW) ||
                  hasPermission(USER_MAINTENANCE_MENU_ACTION_MANAGER_VIEW) ? (
                  <div>
                    <Button
                      icon="pi pi-replay"
                      className="p-button-rounded p-button-help p-button-text"
                      aria-label="Replay"
                      onClick={() => {
                        setFilterObj("");
                        if (regionAdminConfig) {
                          loadRegionUsers(regionAdminConfig.locationId);
                        } else {
                          getUsers({ adminType: true, pageNum: 0, pageSize: size });
                        }
                      }}
                    />
                    <Button
                      icon="pi pi-filter"
                      className="p-button-rounded p-button-help p-button-text"
                      aria-label="Filter"
                      onClick={() => setFilterDialog(true)}
                    />
                    <Button
                      icon="pi pi-upload"
                      className="p-button-rounded p-button-help p-button-text"
                      aria-label="Upload BGV"
                      tooltip="Upload BGV Excel"
                      onClick={() => bgvFileRef.current.click()}
                    />
                  </div>
                ) : (
                  <div>
                    <Button
                      icon="pi pi-replay"
                      className="p-button-rounded p-button-help p-button-text"
                      aria-label="Replay"
                      onClick={() => {
                        setFilterObj("");
                        if (regionAdminConfig) {
                          loadRegionUsers(regionAdminConfig.locationId);
                        } else {
                          getUsers({ adminType: true, pageNum: 0, pageSize: size });
                        }
                      }}
                    />
                    <Button
                      icon="pi pi-filter"
                      className="p-button-rounded p-button-help p-button-text"
                      aria-label="Filter"
                      onClick={() => setFilterDialog(true)}
                    />
                    {!limitFor && (
                      <>
                        <Button
                          icon="pi pi-plus"
                          className="p-button-rounded p-button-help p-button-text"
                          aria-label="Add User"
                          onClick={() => setNewForm(true)}
                        />
                      </>
                    )}
                  </div>
                )}
              </div>
            </span>
          </div>
        </div>
      </Fragment>
    );
  };

  const imageBodyTemplate = (item) => {
    return (
      <div className="flex align-items-center gap-2">
        <span style={{ height: "30px", width: "30px" }}>
          {item.photo === "" || item.photo === null ? (
            <img src={"/assets/images/avtar.png"} alt="" style={{ width: "100%", borderRadius: "50%", overflow: "hidden", border: "1px solid #ccc" }} onError={(e) => (e.target.src = "/assets/images/avtar.png")} />
          ) : (
            <img src={imgPath + item?.photo || ""} alt="" style={{ width: "100%", borderRadius: "50%", overflow: "hidden", border: "1px solid #ccc" }} onError={(e) => (e.target.src = "/assets/images/avtar.png")} />
          )}
        </span>
        <div>{item.firstName + " " + item.lastName}</div>
      </div>
    );
  };

  const onBasicPageChange = (e) => {
    setBasicFirst(e.first);
    setSize(e.rows);
    setPage(page + e.page);
    setBasicRows(e.rows);
    if (regionAdminConfig) {
      loadRegionUsers(regionAdminConfig.locationId);
    } else {
      getUsers({ adminType: true, pageNum: e.page, pageSize: e.rows });
    }
  };

  const footer = (
    <React.Fragment>
      {!filteredRecords && (
        <Paginator
          first={basicFirst}
          rows={basicRows}
          totalRecords={totalRecords}
          onPageChange={onBasicPageChange}
          rowsPerPageOptions={rowsPerPageOptions}
          paginatortemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        ></Paginator>
      )}
    </React.Fragment>
  );

  return (
    <div className="grid ess-page">
      {RoleList()}
      {UserProfile()}
      {BuDialog()}
      {ManagerAction()}
      {Designation()}
      {Allocation()}
      {ReAllocation()}
      {SearchForm()}
      {NewForm()}
      {LeaveUpdate()}
      {updateMarkAttendanceDateDialoge()}
      {BgvConflictDialog()}
      <input type="file" accept=".xlsx,.xls" ref={bgvFileRef} style={{ display: "none" }} onChange={handleBgvFileChange} />
      <div className="col-12">
        <div
          className={classNames(
            {
              "dual-card-container": (hasPermission(LEAVES_ADMIN) || (regionAdminConfig && hasPermission(regionAdminConfig.permission))) && limitFor,
              "card-container": true,
            },
            "p-3 ess-table",
          )}
        >
          <DataTable
            value={users}
            responsiveLayout="scroll"
            header={tableHeader}
            filters={filters1}
            stripedRows
            selectionMode="single"
            selection={clickedUserData}
            onSelectionChange={(e) => setClickedUserData(e.value)}
            dataKey="id"
            filterDisplay="menu"
            globalFilterFields={["name", "email", "ecn", "type"]}
            footer={!filteredRecords ? footer : null}
            paginator={filteredRecords}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={10}
            rowsPerPageOptions={[10, 20, 50]}
            scrollable
            scrollHeight="400px"
            virtualScrollerOptions={{ itemSize: 15 }}
            rowClassName={(data) => data?.background_verification !== true ? { "bgv-unverified-row": true } : {}}
          >
            <Column field="" header="Name" body={imageBodyTemplate} sortable className="initCap"></Column>
            <Column field="email" header="Email Address" sortable></Column>
            <Column field="ecn" header="ECN" sortable></Column>
            <Column field="type" header="Role" sortable></Column>
            <Column field="" header="Designation" body={designationTemplate} sortable></Column>
            <Column field="" header="Business Unit" body={buTemplate} sortable></Column>
            <Column field="" header="BGV" body={bgvBodyTemplate} style={{ width: "60px", textAlign: "center" }}></Column>
            <Column field="" header="Status" body={statusBodyTemplate}></Column>
            <Column header="Actions" style={{ width: "40px", textAlign: "center" }} body={ActionTemplate}></Column>
          </DataTable>
        </div>
        {((hasPermission(LEAVES_ADMIN) && limitFor === "LEAVES_ADMIN") ||
          (regionAdminConfig && hasPermission(regionAdminConfig.permission))) && (
            <>
              <LeaveAdmin clickedUserData={clickedUserData} />
            </>
          )}
      </div>
    </div>
  );
};